import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const supabaseProjectRef = supabaseUrl ? new URL(supabaseUrl).hostname.split('.')[0] : null;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Supabase environment variables are not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your frontend environment.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Use PKCE flow for better security
    flowType: 'pkce',
    // Scope the stored session to the active Supabase project so switching
    // databases does not reuse stale tokens from another environment.
    storageKey: `jema_supabase_auth:${supabaseProjectRef ?? 'default'}`,
  },
  realtime: {
    params: {
      eventsPerSecond: 50, // Increased for smooth real-time messaging
    },
  },
});

export const getRealtimeChannel = (topic: string) => supabase.channel(topic);
